import React from 'react';
import { a as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-53ddb3bb.js';
import styled, { css } from 'styled-components';
import { b as getMargin, a as getPadding } from './styled-utils-3f8463ca.js';

function _templateObject3() {
  var data = _taggedTemplateLiteral(["padding-left: 0;"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["list-style-type: ", ";"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledList = styled.ul(_templateObject(), function (_ref) {
  var listStyle = _ref.listStyle;
  return css(_templateObject2(), listStyle);
}, function (_ref2) {
  var listStyle = _ref2.listStyle;
  return listStyle === 'none' && css(_templateObject3());
}, function (_ref3) {
  var theme = _ref3.theme;
  return getMargin('m-0', theme);
}, function (_ref4) {
  var theme = _ref4.theme,
      padding = _ref4.padding;
  return padding && getPadding(padding, theme);
});

var List = function List(_ref) {
  var children = _ref.children,
      marker = _ref.marker,
      className = _ref.className,
      isNumbered = _ref.isNumbered,
      padding = _ref.padding;
  var listType = isNumbered ? 'ol' : 'ul';
  var listStyle = marker;
  return React.createElement(StyledList, {
    as: listType,
    listStyle: listStyle,
    className: className,
    padding: padding
  }, children);
};

List.defaultProps = {
  className: null,
  isNumbered: false,
  marker: null,
  padding: null
};
List.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "List",
  "props": {
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A custom className you would like to pass to the Component"
    },
    "isNumbered": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether or not this is a number list"
    },
    "marker": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The style of list marker to be used. Any valid CSS listStyleType can be\r\nused, or a custom marker, if required"
    },
    "padding": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The padding value to be applied to the List."
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }]
      },
      "required": true,
      "description": "The content of the List"
    }
  }
};
export default List;
export { List };